__turbopack_context__.v({
  "enrollNow": "EnrollNowSponsoredCertifications-module-scss-module__-mWrtq__enrollNow",
  "root": "EnrollNowSponsoredCertifications-module-scss-module__-mWrtq__root",
});
